import React from "react";
import "./question-resources.scss";

// Question-authored references only. This component neither searches for nor
// invents sources. Callers mount it inside their existing answer-reveal gate.
export function questionResources(refLinks) {
  if (!Array.isArray(refLinks)) return [];
  const seen = new Set();
  return refLinks.reduce((links, value) => {
    if (typeof value !== "string" || !value.trim()) return links;
    try {
      const url = new URL(value.trim());
      if (!["https:", "http:"].includes(url.protocol) || url.username || url.password) return links;
      if (seen.has(url.href)) return links;
      seen.add(url.href);
      links.push({ href: url.href, label: url.hostname.replace(/^www\./, "") });
    } catch (_) {
      // A legacy malformed reference must not break the explanation.
    }
    return links;
  }, []);
}

export default function QuestionResources({ refLinks }) {
  const links = questionResources(refLinks);
  if (!links.length) return null;
  return (
    <section className="question-resources" aria-label="Further reading">
      <h3>Further reading</h3>
      <ul>
        {links.map(({ href, label }, index) => (
          <li key={href}>
            <a href={href} target="_blank" rel="noopener noreferrer">
              {label} <span className="question-resources-number">· Reference {index + 1}</span>
              <span className="question-resources-new-tab"> (opens in a new tab)</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}

const SURGERY_STUDY_RESOURCES = [
  { label: "SCORE curriculum outlines", href: "https://www.absurgery.org/resources/score-curriculum-outlines/" },
  { label: "SAGES practice guidelines", href: "https://www.sages.org/publications/guidelines/" },
  { label: "PubMed literature search", href: "https://pubmed.ncbi.nlm.nih.gov/" },
];

export function SurgeryStudyResources() {
  return (
    <details className="question-resources surgery-study-resources">
      <summary>Surgery study resources</summary>
      <p>General study resources, not references for this particular question.</p>
      <ul>
        {SURGERY_STUDY_RESOURCES.map(({ href, label }) => (
          <li key={href}>
            <a href={href} target="_blank" rel="noopener noreferrer">
              {label}<span className="question-resources-new-tab"> (opens in a new tab)</span>
            </a>
          </li>
        ))}
      </ul>
    </details>
  );
}
